module.exports = __webpack_public_path__ + "img/ZhangChaolin.c7723d4d.png";